module.exports = __webpack_public_path__ + "static/media/bursts_23.3a86bb03.svg";